module.exports = __webpack_public_path__ + "img/ie.7419113c.svg";